import { addLocale } from "primereact/api";

addLocale('tr', {
    startsWith: 'İle Başlayan',
    contains: 'İçeren',
    notContains: 'İçermeyen',
    endsWith: 'İle Biten',
    equals: 'Eşit',
    notEquals: 'Eşit Değil',
    noFilter: 'Filtre Yok',
    lt: 'Küçüktür',
    lte: 'Küçüktür veya Eşittir',
    gt: 'Büyüktür',
    gte: 'Büyüktür veya Eşittir',
    dateIs: 'Tarih Eşittir',
    dateIsNot: 'Tarih Eşit Değil',
    dateBefore: 'Tarih Öncesi',
    dateAfter: 'Tarih Sonrası',
    clear: 'Temizle',
    apply: 'Uygula',
    matchAll: 'Tümünü Eşleştir',
    matchAny: 'Herhangi Birini Eşleştir',
    addRule: 'Kural Ekle',
    removeRule: 'Kuralı Kaldır',
    accept: 'Evet',
    reject: 'Hayır',
    choose: 'Seçiniz',
    upload: 'Yükle',
    cancel: 'İptal',
    dayNames: ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"],
    dayNamesShort: ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cmt"],
    dayNamesMin: ["Pz", "Pt", "Sa", "Ça", "Pe", "Cu", "Ct"],
    monthNames: ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"],
    monthNamesShort: ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"],
    today: 'Bugün',
    weekHeader: 'Hf',
    firstDayOfWeek: 1,
    dateFormat: 'dd/mm/yy',
    weak: 'Zayıf',
    medium: 'Orta',
    strong: 'Güçlü',
    passwordPrompt: 'Şifre Giriniz',
    emptyMessage: 'Kullanılabilir seçenek yok',
    emptyFilterMessage: 'Sonuç bulunamadı',
});
